import secureLocalStorage from 'react-secure-storage';

const randomBichoFetchEmoji = (setRandomPokemon) => {
  fetch('https://vercelcronjobpkmn.vercel.app/api/send-email')
    .then((res) => res.json())
    .then((data) => {
      const secondPokemon = data[2];
      secureLocalStorage.setItem('pokemonInfoRandomEmoji', JSON.stringify(secondPokemon));
      setRandomPokemon(secondPokemon);
    });
};

export const removeAndFetchEmoji = () => {
  secureLocalStorage.removeItem('pokemonInfoRandomEmoji');
  localStorage.removeItem('fetch_count_emoji');
  localStorage.removeItem('pokemonInfoListEmoji');
  localStorage.removeItem('has_won_emoji');
  randomBichoFetchEmoji();
  window.location.reload();
};

export const checkPokemonChangeEmoji = () => {
  const storedPokemon = secureLocalStorage.getItem('pokemonInfoRandomEmoji');
  fetch('https://vercelcronjobpkmn.vercel.app/api/send-email')
    .then((res) => res.json())
    .then((data) => {
      if (storedPokemon && JSON.stringify(data[2]) !== storedPokemon) {
        // El pokemon ha cambiado
        removeAndFetchEmoji();
      } else {
      }
    });
};

export default randomBichoFetchEmoji;
